(() => {
  function scrollAndCleanUrl() {
    if (!window.location.hash) return;

    const targetId = decodeURIComponent(
      window.location.hash.substring(1)
    );

    const target = document.getElementById(targetId);

    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    requestAnimationFrame(() => {
      history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollAndCleanUrl, {
      once: true
    });
  } else {
    scrollAndCleanUrl();
  }

  // Also handles anchor buttons clicked on the same page
  window.addEventListener('hashchange', scrollAndCleanUrl);
})();